import { render, staticRenderFns } from "./reasonsForReportBarChart.vue?vue&type=template&id=8e1c5f58&scoped=true&"
import script from "./reasonsForReportBarChart.vue?vue&type=script&lang=js&"
export * from "./reasonsForReportBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e1c5f58",
  null
  
)

export default component.exports